import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=8b09f714&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=ts"
export * from "./Comments.vue?vue&type=script&lang=ts"
import style0 from "./Comments.vue?vue&type=style&index=0&id=8b09f714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b09f714",
  null
  
)

export default component.exports